import React from 'react';
import { createUseStyles } from 'react-jss';
import VideosSection from './Videos';
import ArticlesSection from './Articles';
import PageHeader from '../Shared/PageHeader';
import { Helmet } from 'react-helmet-async';

function ResourcesPage() {
    const styles = useStyles();
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Resources | Integrated Holistic Psychotherapy",
        "url": "https://inhop.or.ke/resources",
        "description": "Access mental health resources from Integrated Holistic Psychotherapy. Watch our educational videos on counseling, therapy, and wellbeing.",
        "mainEntity": [
            {
                "@type": "VideoObject",
                "name": "INHOP Counseling Services",
                "description": "An educational video by Integrated Holistic Psychotherapy on understanding various services they offer.",
                "thumbnailUrl": "https://img.youtube.com/vi/AoJS6zfd0g0/hqdefault.jpg",
                "uploadDate": "2020-03-03",
                "contentUrl": "https://www.youtube.com/watch?v=AoJS6zfd0g0",
                "embedUrl": "https://www.youtube.com/embed/AoJS6zfd0g0",
                "publisher": {
                    "@type": "Organization",
                    "name": "Integrated Holistic Psychotherapy",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://inhop.or.ke/logo.webp"
                    }
                }
            },
            {
                "@type": "VideoObject",
                "name": "How to overcome Anxiety",
                "description": "An educational video by Integrated Holistic Psychotherapy on How to overcome Anxiety.",
                "thumbnailUrl": "https://img.youtube.com/vi/6rB5dxNxjhM/hqdefault.jpg",
                "uploadDate": "2023-03-28",
                "contentUrl": "https://www.youtube.com/watch?v=6rB5dxNxjhM",
                "embedUrl": "https://www.youtube.com/embed/6rB5dxNxjhM",
                "publisher": {
                    "@type": "Organization",
                    "name": "Integrated Holistic Psychotherapy",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://inhop.or.ke/logo.webp"
                    }
                }
            }
        ]
    };
    return (
        <>
            <Helmet>
                <title>Resources | Integrated Holistic Psychotherapy</title>
                <meta
                    name="description"
                    content="Access mental health resources from us. Watch our educational videos and stay tuned for upcoming articles on counseling, therapy, and wellbeing."
                />
                <meta
                    name="keywords"
                    content="mental health resources, therapy videos Nairobi, counseling articles Kenya, psychotherapy resources, Integrated Holistic Psychotherapy, Ruiru counseling support"
                />
                <link rel="canonical" href="https://inhop.or.ke/resources" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://inhop.or.ke/resources" />
                <meta property="og:title" content="Resources | Integrated Holistic Psychotherapy" />
                <meta
                    property="og:description"
                    content="Explore our mental health resources. Watch therapy and counseling videos, with more articles and guides coming soon."
                />
                <meta property="og:image" content="https://inhop.or.ke/logo.webp" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@inhop20" />
                <meta name="twitter:creator" content="@inhop20" />
                <meta name="twitter:url" content="https://inhop.or.ke/resources" />
                <meta name="twitter:title" content="Resources | Integrated Holistic Psychotherapy" />
                <meta
                    name="twitter:description"
                    content="Mental health resources from Integrated Holistic Psychotherapy. Watch our educational videos, with more articles coming soon."
                />
                <meta name="twitter:image" content="https://inhop.or.ke/logo.webp" />

                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>

            </Helmet>

            <div className={styles.pageContainer}>
                <div className={styles.contactImageHeader}>
                    <PageHeader pageTitle="Resources" />
                </div>
                <div>
                    <ArticlesSection />
                </div>
                <div className={styles.videosContainer}>
                    <VideosSection />
                </div>
            </div>
        </>
    )
}

const useStyles = createUseStyles({
    pageContainer: {
        position: "relative",
        // minWidth: "100vw",
        height: "100%",
        width: "100%",
        fontFamily: "Open Sans, sans-serif",
        display: "flex",
        flexDirection: " column"
    },
})

export default ResourcesPage;
